import * as React from 'react';
import { Field } from 'redux-form';
import Input from '../Input/Input';
import ReactInputMask from 'react-input-mask';

const Time: React.SFC<any> = ({ className, wrapperStyle, disabled, ...rest }) => (
  <div style={wrapperStyle}>
    {disabled && <Input {...rest} disabled={disabled} />}
    {!disabled && (
      <Input {...rest}>
        <ReactInputMask mask={'99:99'} placeholder={'--:--'} value={rest.input.value} />
      </Input>
    )}
  </div>
);
export default Time;
export class TimeField extends Field<any> {}



// WEBPACK FOOTER //
// ./src/components/form/Time/Time.tsx